export default __webpack_public_path__ + "assets/images/7fa3ab0c1e02e217f58f7631ed890306.jpg";